/**
 * Kidify explainers: small illustrated cards that play once when scrolled to
 * (Getting here, CDC vouchers, How lists work).
 *
 * <kidify-explainer data-start='{"step":"0"}' data-timeline='[[600,"step","1"],[900,"tap",null]]'>
 *   <div data-plate data-step="3"> ... </div>
 * </kidify-explainer>
 *
 * The server renders the finished picture, which shoppers see with reduced
 * motion, no JavaScript, or when it is on screen at load. Otherwise the
 * plate is rewound to data-start while fully off screen, so nobody sees it
 * jump back, then the timeline plays once it is half in view. Each timeline
 * entry sets a data attribute on the plate at a time in ms; null removes it.
 * The look of every step lives in the section's CSS.
 */

if (!customElements.get('kidify-explainer')) {
  customElements.define(
    'kidify-explainer',
    class extends HTMLElement {
      #observer = null;
      #timers = [];

      connectedCallback() {
        const plate = this.querySelector('[data-plate]');
        if (!plate || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        let start;
        let timeline;
        try {
          start = JSON.parse(this.dataset.start || '{}');
          timeline = JSON.parse(this.dataset.timeline || '[]');
        } catch {
          return;
        }
        const finished = { ...plate.dataset };
        let rewound = false;
        this.#observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.intersectionRatio === 0) {
              if (rewound) return;
              rewound = true;
              plate.dataset.instant = '';
              for (const key of Object.keys(finished)) if (key !== 'plate') delete plate.dataset[key];
              Object.assign(plate.dataset, start);
              plate.offsetWidth;
              delete plate.dataset.instant;
            } else if (rewound && entry.intersectionRatio >= 0.5) {
              this.#observer.disconnect();
              for (const [at, key, value] of timeline) {
                this.#timers.push(
                  setTimeout(() => {
                    if (value === null) delete plate.dataset[key];
                    else plate.dataset[key] = value;
                  }, at)
                );
              }
            }
          },
          { threshold: [0, 0.5] }
        );
        this.#observer.observe(plate);
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#timers.forEach(clearTimeout);
        this.#timers = [];
      }
    }
  );
}
